import { combineReducers } from "redux";
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector
} from "react-redux";
import userReducer from "common/redux/user/user.slice";
import appReducer from "common/redux/app/app.slice";
import documentListReducer from "modules/documents/data/redux/document-list/document-list.slice";
import documentSetupReducer from "modules/documents/data/redux/document-setup/document-setup.slice";
import documentDetailsReducer from "modules/documents/data/redux/document-details/document-details.slice";
import { documentTypeReducer } from "modules/_shared/redux/document-type";
import {
  reducer as apiReducer,
  reducerPath as apiReducerPath
} from "common/redux/core/api.base";

import { AppDispatch } from "./store.config";

const rootReducer = combineReducers({
  app: appReducer,
  user: userReducer,
  documentList: documentListReducer,
  documentSetup: documentSetupReducer,
  documentDetails: documentDetailsReducer,
  documentType: documentTypeReducer,
  [apiReducerPath]: apiReducer
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
